import React from "react";
import { createPortal } from "react-dom";

const MOBILE_FAB_CLASS =
  "fixed right-6 bottom-[calc(110px+env(safe-area-inset-bottom,0px))] w-14 h-14 rounded-full shadow-xl flex items-center justify-center active:scale-90 transition-all z-[70] ring-4 ring-white/30";

export default function MobileFloatingActionButton({
  onClick,
  className = "bg-[#354F38] text-white",
  ariaLabel,
  title,
  children,
}) {
  const [isVisible, setIsVisible] = React.useState(false);

  React.useEffect(() => {
    const rafId = window.requestAnimationFrame(() => {
      setIsVisible(true);
    });
    return () => window.cancelAnimationFrame(rafId);
  }, []);

  if (typeof document === "undefined") return null;

  return createPortal(
    <button
      type="button"
      onClick={onClick}
      className={`${MOBILE_FAB_CLASS} ${className} ${
        isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-1 pointer-events-none"
      }`}
      aria-label={ariaLabel}
      title={title}
    >
      {children}
    </button>,
    document.body
  );
}
